import { all, call, fork, put, take } from 'redux-saga/effects';
import { activeChipRootSaga } from './widgets/ActiveChip';
import { authRootSaga } from './widgets/Auth/sagas/root';

import { betDoubleRootSaga } from './widgets/BetDouble';
import { betRepeatRootSaga } from './widgets/BetRepeat';
import { gameRulesSaga } from './widgets/GameRules';
import { userRootSaga } from './widgets/User';
import { webSocketRootSaga } from './widgets/WebSocket';
import { watchDatesControlSaga } from './watchDatesControlSaga';
import { historySaga } from './widgets/History';
import { watchDecrementTimeLeftSaga } from './watchDecrementTimeLeftSaga';
import { chatSaga } from './widgets/ChatPanel/sagas/root';
import { webSocketChatRootSaga } from './widgets/WebSocket/sagas/root';
import { rouletteBetRootSaga } from './widgets/RouletteBet/sagas/root';

export function* rootSaga() {
  // const taskChannel = createTaskChannel() as any;
  // yield fork(processTasks, taskChannel);

  try {
    yield all([
      webSocketRootSaga(),
      authRootSaga(),
      activeChipRootSaga(),
      userRootSaga(),
      betDoubleRootSaga(),
      betRepeatRootSaga(),
      gameRulesSaga(),
      watchDatesControlSaga(),
      watchDecrementTimeLeftSaga(),
      historySaga(),
      webSocketChatRootSaga(),
      chatSaga(),
      rouletteBetRootSaga(),
    ]);
  } catch (e) {
    global.console.log(e);
  }
}
